import useOpenApiClient from '@/hooks/useOpenApiClient';
import { components } from '@/types/api';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import TransactionReceipt from '@/assets/icons/transaction_receipt.svg?react';

export function PlaidAccountActivites({
  account,
}: {
  account: components['schemas']['AccountDetailsOutput'];
}) {
  const { apiFetch } = useOpenApiClient();

  const accountActivitiesQuery = useQuery({
    queryKey: ['v1', 'accounts', account?.id, 'activities'],
    queryFn: () =>
      apiFetch.GET('/accounts/{account_id}/activities', {
        params: {
          path: { account_id: account?.id },
        },
      }),
    enabled: Boolean(account?.id),
    select: (data) =>
      data.data?.data?.reduce(
        (prev, curr) => {
          const transactionMonthAndDate = format(new Date(curr.transaction_date), 'MMM d');
          prev[transactionMonthAndDate] = [...(prev[transactionMonthAndDate] || []), curr];
          return prev;
        },
        {} as Record<string, components['schemas']['AccountActivity'][]>,
      ),
  });

  return (
    <div className="overflow-y-auto">
      {Object.entries(accountActivitiesQuery.data || {}).map(([monthAndDate, activities]) => (
        <div key={monthAndDate} className="mt-4">
          <h3 className="px-3 text-sm font-bold">{monthAndDate}</h3>
          <div className="mt-1.5 flex flex-col rounded-[10px] bg-white p-3">
            {activities.map((activity) => (
              <div
                key={activity.id}
                className="border-b-primary-dark/10 flex items-center justify-between border-b py-1.5"
              >
                <div className="flex flex-auto items-center gap-5">
                  <TransactionReceipt />
                  <div>
                    <strong>{activity.merchant_name}</strong>
                    <p className="text-primary-dark/50 text-sm">{activity.description}</p>
                  </div>
                </div>
                <p>${activity.amount}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
